import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import messages from './messages';

import Slider from 'components/forms/Slider';
import { MIN_CHANGE_RANGE, MAX_CHANGE_RANGE } from './constants';

const Container = styled.div`
    padding: 0 50px;
`;

const ChangePeriodControls = ({ disabled, defaultRange, onChangeRange }) => {
    const displayLabel = (range) => <FormattedMessage {...messages.sliderMarkLabel} values={{ range }} tagName="div" />;
    const marks = [MIN_CHANGE_RANGE, 4, MAX_CHANGE_RANGE].reduce(
        (accu, range) => ({
            ...accu,
            [range]: displayLabel(range),
        }),
        {},
    );
    return (
        <Container>
            <FormattedMessage {...messages.sliderTitle} />
            <Slider
                defaultValue={defaultRange}
                min={MIN_CHANGE_RANGE}
                max={MAX_CHANGE_RANGE}
                step={1}
                onAfterChange={onChangeRange}
                marks={marks}
                tooltipFormatter={displayLabel}
                disabled={disabled}
            />
        </Container>
    );
};

export default ChangePeriodControls;
